/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CommunicationTemplateGetEmailMacrosGet$Params {
}

export function communicationTemplateGetEmailMacrosGet(http: HttpClient, rootUrl: string, params?: CommunicationTemplateGetEmailMacrosGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, communicationTemplateGetEmailMacrosGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<string>>;
    })
  );
}

communicationTemplateGetEmailMacrosGet.PATH = '/CommunicationTemplate/GetEmailMacros';
